function trackEvent(eventName: string, params: Record<string, string | number>): void {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}

export function trackBlogArticleView(
  articleSlug: string,
  articleTitle: string,
  articleSilo: string,
  readingMinutes: number,
): void {
  trackEvent('blog_article_view', {
    article_slug: articleSlug,
    article_title: articleTitle,
    article_silo: articleSilo,
    reading_minutes: readingMinutes,
  });
}

export function trackBlogScrollDepth(articleSlug: string, depthPercent: 25 | 50 | 75 | 100): void {
  trackEvent('blog_scroll_depth', {
    article_slug: articleSlug,
    depth_percent: depthPercent,
  });
}

export function trackBlogCtaClick(ctaLabel: string, articleSlug?: string): void {
  trackEvent('blog_cta_click', {
    cta_label: ctaLabel,
    ...(articleSlug ? { article_slug: articleSlug } : {}),
  });
}

export function trackBlogIndexView(siloFilter: string): void {
  trackEvent('blog_index_view', {
    silo_filter: siloFilter,
  });
}

export function trackBlogSiloView(siloId: string): void {
  trackEvent('blog_silo_view', {
    silo_id: siloId,
  });
}

export type WebsiteOfferCtaChannel = 'form' | 'whatsapp' | 'phone';

export function trackWebsiteOfferCta(location: string, channel: WebsiteOfferCtaChannel): void {
  trackEvent('website_offer_cta_click', {
    cta_location: location,
    channel,
  });
}

export function trackLead(service: string): void {
  trackEvent('generate_lead', { service });
}

export type ContactChannel = 'whatsapp' | 'phone';

export type ContactService = 'depannage' | 'reparation-telephone' | 'site-web' | 'autre';

export type ContactCtaLocation =
  | 'hero'
  | 'pricing'
  | 'footer'
  | 'cta'
  | 'card'
  | 'contact'
  | 'estimator'
  | 'service-area'
  | 'legal'
  | 'article'
  | 'coverage'
  | 'form'
  | 'modal';

export interface ContactCtaClickParams {
  channel: ContactChannel;
  service: ContactService;
  cta_location: ContactCtaLocation;
}

export function contactCtaClick({ channel, service, cta_location }: ContactCtaClickParams): void {
  trackEvent('contact_cta_click', {
    channel,
    service,
    cta_location,
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
  });
}
